import { UserResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";

export type StableThreadMessage = {
  id: string;
  text: string | undefined;
  user: UserResponse<DefaultStreamChatGenerics> | null | undefined;
  created_at: string | undefined;
  reply_count: number | undefined;
};

export const aiErrorMessage =
  "I'm not able to help with this particular request right now. Please reach out to our support team for assistance with this query.";

export const THREAD_FEEDBACK_RATING = {
  PERFECTLY_ANSWERED: "PERFECTLY_ANSWERED",
  PARTIALLY_CORRECT: "PARTIALLY_CORRECT",
  COMPLETELY_OFF: "COMPLETELY_OFF",
};

export const THREAD_FEEDBACK_RATING_DISPLAY = {
  [THREAD_FEEDBACK_RATING.PERFECTLY_ANSWERED]: "Perfectly answered the query",
  [THREAD_FEEDBACK_RATING.PARTIALLY_CORRECT]:
    "Was on track but gave a wrong answer",
  [THREAD_FEEDBACK_RATING.COMPLETELY_OFF]:
    "Totally went off the track and gave a random answer",
};
